/* Woodlit G4 cart drawer and /cart (roadmap R06, R10). SB-P0 part; SB12 appends the assembly, pairing, area check and link handlers.
   No contact-tap events here: G1's binder fires tel_tap, whatsapp_tap and email_tap. Events go through window.wlTrack only. */
(function () {
  if (window.wlG4Cart) return; window.wlG4Cart = true;
  var html = document.documentElement;
  var UNLOCK_MS = 3000;
  var JSON_HDR = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function track(e, p) { try { if (typeof window.wlTrack === 'function') window.wlTrack(e, p || {}); } catch (x) {} }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function placement(el) {
    var host = el && el.closest && el.closest('[data-wl-placement]');
    if (host) return host.getAttribute('data-wl-placement');
    return el && el.closest && el.closest('cart-drawer') ? 'drawer' : 'cart_page';
  }
  function post(path, body) { return fetch(root() + path, { method: 'POST', headers: JSON_HDR, body: JSON.stringify(body) }); }

  /* ---------- R06 (3) terms ---------- */
  function termsBlock(form) { return form ? form.querySelector('[data-wl-terms]') : null; }
  function boxOf(block) { return block ? block.querySelector('[data-wl-terms-input]') : null; }
  function lock(form, on) {
    if (!form) return;
    var w = form.querySelector('[data-wl-wallets]'), sh = form.querySelector('[data-wl-wallet-shield]');
    if (w) { if (on) w.setAttribute('inert', ''); else w.removeAttribute('inert'); }
    if (sh) sh.hidden = !on;
  }
  function clearError(block) {
    if (!block) return;
    var box = boxOf(block), err = block.querySelector('[data-wl-terms-error]');
    block.classList.remove('is-invalid'); if (box) box.removeAttribute('aria-invalid'); if (err) err.hidden = true;
  }
  function prompt(block, via) {
    var box = boxOf(block), err = block.querySelector('[data-wl-terms-error]');
    block.classList.add('is-invalid'); if (err) err.hidden = false;
    if (box) { box.setAttribute('aria-invalid', 'true'); try { box.focus({ preventScroll: true }); } catch (x) { box.focus(); } }
    if (block.scrollIntoView) block.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    track('cart_terms_prompt', { placement: placement(block), value: via });
  }
  function writeAttr(box) {
    var form = box.form || box.closest('form');
    var name = box.getAttribute('data-wl-terms-attr');
    var seq = (box.__wlSeq = (box.__wlSeq || 0) + 1);
    if (!box.checked) { lock(form, true); if (form) form.removeAttribute('data-wl-terms-pending'); }
    else if (form) form.setAttribute('data-wl-terms-pending', '');
    var done = false, timer = null;
    function finish() {
      if (done) return; done = true; if (timer) clearTimeout(timer);
      if (seq !== box.__wlSeq) return;               /* a newer toggle owns the state */
      if (form) form.removeAttribute('data-wl-terms-pending');
      lock(form, !box.checked);
    }
    timer = setTimeout(finish, UNLOCK_MS);
    if (!name) { finish(); return; }
    var a = {}; a[name] = box.checked ? 'Yes' : '';
    post('cart/update.js', { attributes: a }).then(finish, finish);
  }
  function sync() {
    document.querySelectorAll('[data-wl-terms-input]').forEach(function (box) {
      var form = box.form || box.closest('form');
      if (form) form.removeAttribute('data-wl-terms-pending');
      lock(form, !box.checked);
      if (box.checked) clearError(box.closest('[data-wl-terms]'));
    });
    html.classList.toggle('wl-g4-drawer-open', !!document.querySelector('cart-drawer.is-open'));
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-cart-form]')) return;
    var sub = e.submitter;
    if (sub && sub.name && sub.name !== 'checkout') return;   /* /cart "Update" (no-js) */
    var block = termsBlock(form), box = boxOf(block);
    if (box && !box.checked) { e.preventDefault(); e.stopImmediatePropagation(); prompt(block, 'button'); return; }
    var v = box ? 'ticked' : (form.querySelector('[data-wl-terms-line]') ? 'line' : 'none');
    track('cart_checkout_click', { placement: placement(form), value: v });
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var box = t.closest('[data-wl-terms-input]');
    if (box) { if (box.checked) clearError(box.closest('[data-wl-terms]')); writeAttr(box); }
  });

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var sh = t.closest('[data-wl-wallet-shield]');
    if (sh) {
      e.preventDefault(); e.stopPropagation();
      var form = sh.closest('form');
      if (form && form.hasAttribute('data-wl-terms-pending')) return;
      var b = termsBlock(form); if (b) prompt(b, 'wallet');
      return;
    }
    var cta = t.closest('[data-wl-empty-cta]');
    if (cta) track('cart_empty_cta', { placement: placement(cta) });
  }, true);

  /* ---------- floats (G1 R05 contract) ---------- */
  document.addEventListener('theme:cart-drawer:open', function () { html.classList.add('wl-g4-drawer-open'); });
  document.addEventListener('theme:cart-drawer:close', function () { html.classList.remove('wl-g4-drawer-open'); });

  window.addEventListener('pageshow', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();